export default __webpack_public_path__ + "static/media/down-black.466aae7a.svg";